import React, { FC, Fragment } from "react";
import { useIntl } from "react-intl";

import {
  TemplateCardNavigationVariant,
  TemplateCardNavigationViewProps,
} from "../../../cards/TemplateCard";
import { withLoaderHOC, WithLoaderHOC } from "../../../../atoms/Loader";
import { NoTemplatesContainer } from "./styles";

const NavigationModuleDropdownVariant: FC<Props> = ({
  templateData,
  onClickSideEffects,
}) => {
  const { formatMessage } = useIntl();

  if (templateData.length === 0) {
    return (
      <NoTemplatesContainer>
        {formatMessage({ id: "common.empty_list" })}
      </NoTemplatesContainer>
    );
  }

  return (
    <Fragment>
      {templateData.map(({ id, ...rest }) => (
        <TemplateCardNavigationVariant
          {...rest}
          key={id}
          data-cy="test"
          onClick={onClickSideEffects}
        />
      ))}
    </Fragment>
  );
};

export type TemplateData = TemplateCardNavigationViewProps & { id: number };

type Props = {
  templateData: TemplateData[];
  onClickSideEffects?(): void;
};

export default withLoaderHOC(NavigationModuleDropdownVariant);
export type ControlledProps = WithLoaderHOC<Props>;
